import { render, staticRenderFns } from "./sourceMaterial.vue?vue&type=template&id=6679c459&scoped=true&"
import script from "./sourceMaterial.vue?vue&type=script&lang=js&"
export * from "./sourceMaterial.vue?vue&type=script&lang=js&"
import style0 from "./sourceMaterial.vue?vue&type=style&index=0&id=6679c459&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6679c459",
  null
  
)

export default component.exports